import React, { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useApp } from "@/context";
import DepartmentSelectGrid from "@/components/catalog/DepartmentSelectGrid";

/**
 * Browse — departments-only storefront entry (Aug 2026).
 * Picking a department goes STRAIGHT to /shop?department=… (no category stage).
 * Old deep links like /browse?dept=flowers redirect to the shop automatically.
 */
export default function Browse() {
  const { lang } = useApp();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const dept = params.get("dept");

  useEffect(() => {
    if (dept) navigate(`/shop?department=${encodeURIComponent(dept)}`, { replace: true });
  }, [dept, navigate]);

  return (
    <div className="space-y-5 max-w-6xl mx-auto px-3 sm:px-5 py-4 sm:py-6"
         data-testid="browse-page">
      <header>
        <h1 className={`${lang === "ar" ? "font-display-ar" : "font-display-en"} text-xl sm:text-2xl`}>
          {lang === "ar" ? "اختر القسم" : "Choose the shop"}
        </h1>
      </header>
      <DepartmentSelectGrid />
    </div>
  );
}
